import React from 'react';

import Button from '@pb/kit-component-button';
import {Group, Item} from '@pb/kit-component-group';
import {Loading, Types} from '@pb/kit-component-loading';

type Props = {
    onAiReview: () => void,
    inReview: boolean,
    isDisabled: boolean,
};

export const EventCreateReviewView = ({onAiReview, inReview, isDisabled}: Props) => {
    return (
        <Group alignItems="center">
            <Button
                className="ai-review-tour"
                disabled={isDisabled}
                variant="Type.PRIMARY"
                onClick={onAiReview}>
                AI Review
            </Button>
            {inReview ? (
                <Group>
                    <Loading fast={true} type={Types.ICON}/>
                    <Item>Review in progress...</Item>
                </Group>
            ) : null}
        </Group>
    );
};
